// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cntChargeEmailButton {\n  margin-top: 3px;\n}", "",{"version":3,"sources":["webpack://./app/javascript/components/polizas/show/chargeEmailButton.scss"],"names":[],"mappings":"AAAA;EAEE,eAAA;AAAF","sourcesContent":[".cntChargeEmailButton {\n\n  margin-top: 3px;\n \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
